angular
    .module("empower.index", [
        "index.controller",
        'index.service',
    ]);